// 카카오톡/네이버 인앱 브라우저는 키보드가 떠도 문서 스크롤 영역이 늘어나지 않아
// .btn_area 확인 버튼이 키보드에 가려진 채 스크롤도 안 되는 경우가 있다.
// visualViewport로 키보드 높이를 직접 감지해 .wapper에 여분 공간을 만들어준다.
function getKeyboardHeight() {
  const vv = window.visualViewport;
  if (!vv) return 0;
  return Math.max(0, window.innerHeight - vv.height - vv.offsetTop);
}

export default {
  inserted(el) {
    if (!window.visualViewport) return;

    const container = el.closest('.conts');
    const wapperEl = container && container.querySelector('.wapper');
    const btnAreaEl = container && container.querySelector('.btn_area');
    if (!wapperEl || !btnAreaEl) return;

    const adjust = () => {
      const keyboardHeight = getKeyboardHeight();
      wapperEl.style.paddingBottom = keyboardHeight > 0 ? `${keyboardHeight + 60}px` : '';
      if (keyboardHeight > 0) {
        btnAreaEl.scrollIntoView({ block: 'end' });
      }
    };

    const onFocus = () => {
      window.visualViewport.addEventListener('resize', adjust);
      window.visualViewport.addEventListener('scroll', adjust);
      adjust();
    };

    const onBlur = () => {
      window.visualViewport.removeEventListener('resize', adjust);
      window.visualViewport.removeEventListener('scroll', adjust);
      wapperEl.style.paddingBottom = '';
    };

    el.addEventListener('focus', onFocus);
    el.addEventListener('blur', onBlur);

    el.__keyboardScrollCleanup = () => {
      el.removeEventListener('focus', onFocus);
      el.removeEventListener('blur', onBlur);
      window.visualViewport.removeEventListener('resize', adjust);
      window.visualViewport.removeEventListener('scroll', adjust);
      wapperEl.style.paddingBottom = '';
    };
  },
  unbind(el) {
    if (el.__keyboardScrollCleanup) {
      el.__keyboardScrollCleanup();
      delete el.__keyboardScrollCleanup;
    }
  },
};
